function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 c -0.282 0 -0.551 -0.119 -0.741 -0.328 l -20 -22.044 c -0.266 -0.293 -0.334 -0.715 -0.174 -1.077 c 0.161 -0.361 0.519 -0.595 0.915 -0.595 h 9.08 V 45.431 c 0 -0.349 0.182 -0.672 0.479 -0.854 c 0.296 -0.183 0.667 -0.196 0.979 -0.035 l 19.841 10.219 c 0.333 0.171 0.542 0.515 0.542 0.889 v 10.307 H 65 c 0.396 0 0.754 0.233 0.914 0.595 c 0.16 0.362 0.093 0.784 -0.174 1.077 l -20 22.044 C 45.551 89.881 45.282 90 45 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 54.921 45.569 c -0.157 0 -0.313 -0.037 -0.458 -0.111 L 34.622 35.239 c -0.333 -0.171 -0.542 -0.515 -0.542 -0.889 V 24.044 H 25 c -0.396 0 -0.754 -0.233 -0.915 -0.595 c -0.16 -0.361 -0.092 -0.784 0.174 -1.077 l 20 -22.044 c 0.379 -0.418 1.103 -0.418 1.481 0 l 20 22.044 c 0.267 0.293 0.334 0.715 0.174 1.077 c -0.16 0.362 -0.519 0.595 -0.914 0.595 h -9.079 v 20.525 c 0 0.349 -0.182 0.672 -0.479 0.854 C 55.282 45.521 55.102 45.569 54.921 45.569 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.692935be3cb4e9d143aa00b2119cd9e4.svg";
export { ForwardRef as ReactComponent };